// Indian states and union territories for the site form's State select.
// Stored verbatim in `assets.location_state` (free text on the backend), so the
// labels double as the values.

import type { SelectOption } from "@/app/console/forms";

export const INDIAN_STATES: ReadonlyArray<string> = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

export const INDIAN_UNION_TERRITORIES: ReadonlyArray<string> = [
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

export const STATE_OPTIONS: ReadonlyArray<SelectOption<string>> = [...INDIAN_STATES, ...INDIAN_UNION_TERRITORIES].map((s) => ({
  value: s,
  label: s,
}));
